import { createFileRoute } from "@tanstack/react-router";

import { AdminHealth } from "@/features/admin";

export const Route = createFileRoute("/_authed/_modal/admin/health")({
  component: AdminHealth,
});
